import { render, staticRenderFns } from "./BlipArtist.vue?vue&type=template&id=0c48f6ae&"
import script from "./BlipArtist.vue?vue&type=script&lang=js&"
export * from "./BlipArtist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports